/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Request_ButtonInputs */

const en_delete_account_request_button = /** @type {(inputs: Delete_Account_Request_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Account Deletion`)
};

const es_delete_account_request_button = /** @type {(inputs: Delete_Account_Request_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar eliminación de cuenta`)
};

const ar_delete_account_request_button = /** @type {(inputs: Delete_Account_Request_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طلب حذف الحساب`)
};

/**
* | output |
* | --- |
* | "Request Account Deletion" |
*
* @param {Delete_Account_Request_ButtonInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_request_button = /** @type {((inputs?: Delete_Account_Request_ButtonInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Request_ButtonInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_request_button(inputs)
	if (locale === "es") return es_delete_account_request_button(inputs)
	return ar_delete_account_request_button(inputs)
});